import { useRouter } from 'next/router';
import Head from 'next/head';
import Moment from 'react-moment';
import moment from 'moment';
import InvestmentForm from '../../../../components/investment-form/investment-form';
import Layout from '../../../../components/layouts/layout';
import ScheduleForm from '../../../../components/schedule-form/schedule-form';
import TrainingsNav from '../../../../components/trainings-nav/trainings-nav';
import { addApolloState, initializeApollo } from '../../../../lib/apolloClient';
import fetchRetreats from '../../../../lib/queries/fetchRetreats';
import BookNowFooter from '../../../../components/booknow-footer/booknow-footer';
import CkeditorRenderer from '../../../../components/ckeditor-renderer/ckeditor-renderer';
import { getStrapiMedia } from '../../../../lib/utils';
import useResponsive from '../../../../lib/useResponsive';
import ImageContainer from '../../../../components/image-container/image-container';
import styles from './program.module.scss';

export default function Location({ training }) {
  const { isDesktop } = useResponsive();
  const router = useRouter();

  const submitInvestment = () => {
    router.push(`/checkout/retreat/${training?.slug}`);
  };

  return (
    <Layout
      logoType="small"
      showJoinMail={false}
      bookNow={
        <BookNowFooter
          title={training?.title}
          location={training?.location}
          start_date={training?.start_date}
          end_date={training?.end_date}
          isDesktop={isDesktop}
          refBook={`/checkout/retreat/${training?.slug}`}
        ></BookNowFooter>
      }
    >
      <Head>
        <title>
          {training?.title} ({training?.location}) | Program - The Sacred Fig
        </title>
        <meta name="description" content={training?.short_description} />
        <meta name="image" content={getStrapiMedia(training?.featured_image)} />
      </Head>
      <TrainingsNav slug={training?.slug} type="retreats"></TrainingsNav>

      {/* daily schedule */}
      <div className={styles.schedule}>
        <div
          className={styles.item}
          style={{
            border: 'none',
            margin: isDesktop ? 'auto' : 'unset',
            padding: isDesktop ? 'auto' : '',
          }}
        >
          <div className={styles.left}>
            <p className={styles.category}>{training?.daily_schedule?.title}</p>
          </div>
          <div className={`${styles.right} ${styles.description}`}>
            <CkeditorRenderer html={training?.daily_schedule?.description}></CkeditorRenderer>
          </div>
        </div>
        {training?.daily_schedule?.details?.map((schedule, i) => {
          const start = moment.duration(schedule.start_time).minutes();
          const end = moment.duration(schedule.end_time).minutes();
          return (
            <>
              <div className={styles.item} key={i}>
                <div className={styles.left}>
                  <div className={styles.title}>
                    <Moment format={start === 0 ? 'h a' : 'h:mm a'} date={`1976-04-19 ${schedule.start_time}`}></Moment>
                    {!schedule.start_time_only && (
                      <>
                        &nbsp;-&nbsp;
                        <Moment format={end === 0 ? 'h a' : 'h:mm a'} date={`1976-04-19 ${schedule.end_time}`}></Moment>
                      </>
                    )}
                  </div>
                </div>
                <div className={styles.right}>
                  <div className={styles.description}>{schedule.description}</div>
                </div>
              </div>
            </>
          );
        })}
      </div>

      {isDesktop && training?.investment && (
        <InvestmentForm
          investment={training?.investment}
          isDesktop={isDesktop}
          onSubmit={submitInvestment}
          startDate={training?.start_date}
          isRetreat={true}
        ></InvestmentForm>
      )}
    </Layout>
  );
}

export async function getStaticPaths() {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: fetchRetreats,
  });

  // Get the paths we want to pre-render based
  const paths = data.retreats.map((training) => `/retreats/${training.slug}/program`);

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: true };
}

export async function getStaticProps({ params }) {
  const apolloClient = initializeApollo();

  const { data } = await apolloClient.query({
    query: fetchRetreats,
    variables: { slug: params.slug },
  });

  return addApolloState(apolloClient, {
    props: { training: data.retreats[0] },
    revalidate: 1,
  });
}
